import React, { useEffect, useMemo, useRef, useState } from "react";
import "../styles/gallery.css";
import Zoomimage from "../../../Component/Zoomimage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Gallery = ({
  loading,
  mainimage,
  quality_name,
  designShade,
  images = [],
}) => {

  const galleryImages = useMemo(() =>
    images.length > 0
      ? Object.keys(images[0])
          .filter(
            (key) =>
              key.startsWith("designshadeimage_") && images[0][key]
          )
          .sort()
          .map((key, index) => ({
            id: index + 1,
            src: images[0][key],
          }))
      : [],
    [images]
  );

  const allImages = useMemo(() => {
    if (galleryImages.length > 0) {
      return galleryImages;
    }

    if (mainimage) {
      return [{ id: 1, src: mainimage }];
    }

    return [];
  }, [galleryImages, mainimage]);

  const [mainImage, setMainImage] = useState(mainimage);
  const [activeThumbnail, setActiveThumbnail] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const isMobile = window.innerWidth <= 768;
  const thumbnailsPerPage = isMobile ? 4 : 6;
  const isScrollable = allImages.length > thumbnailsPerPage;
  const thumbnailImages = useMemo(() => {
    const images = [...allImages];
    if (images.length >= 2) {
      [images[0], images[1]] = [images[1], images[0]];
    }
    return images;
  }, [allImages]);

useEffect(() => {
  if (thumbnailImages.length > 0) {
    setMainImage(thumbnailImages[0].src);
    setActiveThumbnail(thumbnailImages[0].id);
    setStartIndex(0);
  }
}, [mainimage, images, thumbnailImages]);

  const handleThumbnailClick = (src, id) => {
    setMainImage(src);
    setActiveThumbnail(id);
  };

 const handleUp = () => {
  if (startIndex > 0) {
    setStartIndex((prev) => prev - 1);
  }
};

const handleDown = () => {
  if (startIndex < thumbnailImages.length - thumbnailsPerPage) {
    setStartIndex((prev) => prev + 1);
  }
};

const [designShadeChanged, setDesignShadeChanged] = useState(false);
const previousDesignShade = useRef(designShade);
useEffect(() => {
  if (
    previousDesignShade.current &&
    previousDesignShade.current !== designShade
  ) {
    setDesignShadeChanged(true);
    const timer = setTimeout(() => {
      setDesignShadeChanged(false);
    }, 2000);
    previousDesignShade.current = designShade;
    return () => clearTimeout(timer);
  }
  previousDesignShade.current = designShade;
}, [designShade]);





  // FULL GALLERY SKELETON
  if (loading) {
    return (
     <div className="gallery-container">
  <Skeleton
    width="100%"
    height={580}
    containerClassName="w-100"
    borderRadius={8}
  />
</div>
    );
  }

  return (
    <>
      <div className="gallery-container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="gallery-title text-center">
              <span className="quality-name text-danger">
                {quality_name}
              </span>

              <span
                className={`design-shade ${
                  designShadeChanged ? "changed" : ""
                }`}
              >
                {" "}

                {designShade?.split(" ").map((word, index, words) => {
                  return (
                    <span key={index}>
                      {index === 0
                        ? word.split(/(\d+)/).map((part, i) =>
                            /^\d+$/.test(part) ? (
                              <span key={i}>{part}</span>
                            ) : (
                              <strong key={i}>{part}</strong>
                            )
                          )
                        : word}

                      {index < words.length - 1 && " "}
                    </span>
                  );
                })}
              </span>
            </h2>
          </div>
          {/* THUMBNAILS */}
          <div className="col-md-2 col-3 padding002">
            <div className="thumbnail-wrapper">
              {isScrollable && (
                <button
                  className="thumb-btn up"
                  onClick={handleUp}
                  disabled={startIndex === 0}
                >
                  <i className="bi bi-chevron-up"></i>
                </button>
              )}

              <div
                className="thumbnail-container"
                style={{
                  height: "600px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {thumbnailImages
                  .slice(startIndex, startIndex + thumbnailsPerPage)
                  .map((img) => (
                    <img
                      key={img.id}
                      src={img.src}
                      alt=""
                      loading="lazy"
                      onClick={() => handleThumbnailClick(img.src, img.id)}
                      className={`thumbnail ${
                        activeThumbnail === img.id ? "active" : ""
                      }`}
                      style={{
                        height: "80px",
                        objectFit: "cover",
                        cursor: "pointer",
                        border:
                          activeThumbnail === img.id
                            ? "2px solid rgb(248 205 5)"
                            : "1px solid #ddd",
                      }}
                    />
                  ))}
              </div>

              {isScrollable && (
                <button
                  className="thumb-btn down"
                  onClick={handleDown}
                  disabled={
                    startIndex >=
                    thumbnailImages.length - thumbnailsPerPage
                  }
                >
                  <i className="bi bi-chevron-down"></i>
                </button>
              )}
            </div>
          </div>
          {/* MAIN IMAGE */}
          <div className="col-md-10 col-9">
            <div className="main-image">
              
              {mainImage && (
              <> 
                <img
                  src={mainImage}
                  className="main-image-img"
                  alt=""
                  onClick={() => setShowModal(true)}
                  loading="lazy"
                />
                
              <span
                className="zoomicon"
                onClick={() => setShowModal(true)}
                >
                <i className="bi bi-zoom-in"></i>
              </span>
                 </>
              )}
            </div>
          </div>

</div>
</div>
      <Zoomimage
        showModal={showModal}
        handleCloseModal={() => setShowModal(false)}
        modalImage={mainImage}
      />
    </>
  );
};
export default Gallery;